
    var riot = require('riot')
    riot.tag2('checkout-modal', '<div class="selling-bankid-modal checkout-modal"> <div data-ng-if="!showBankIdProgress && !showBankIdError"> <header> <h2>{opts.model.title}</h2> <h3><raw></raw> </h3> </header> <div> <div if="{opts.model.showProgressIcon}" class="spinner"></div> <div if="{opts.model.showErrorIcon}" class="icon-error"></div> <div if="{opts.model.showSuccessIcon}" class="icon-check"></div> <div class="checkout-modal-text"> <article class="grid-wrapper"> {opts.model.text} </article> <div if="{opts.model.bodyTagName}" class="bodyTagContent"></div> </div> <div if="{opts.model.buttons}" class="grid-wrapper"> <ol if="{opts.model.buttons.primary && opts.model.buttons.secondary}" class="grid-1-2"> <li class="grid-item right"> <button class="primary-action-rounded" onclick="{primaryClick}">{opts.model.buttons.primary.title}</button> </li> <li class="grid-item"> <button class="secondary-action-rounded" onclick="{secondaryClick}">{opts.model.buttons.secondary.title}</button> </li> </ol> <ol if="{!opts.model.buttons.primary && opts.model.buttons.secondary}"> <li> <button class="primary-action-rounded" onclick="{secondaryClick}">{opts.model.buttons.secondary.title}</button> </li> </ol> </div> </div> </div> </div>', '', '', function(opts) {

        this.on('mount',
            function() {
                if (opts.model.bodyTagName) {
                    riot.mount('.bodyTagContent', opts.model.bodyTagName);
                }
                if (opts.model.subTitleHtml) {
                    riot.mount('raw', { html: opts.model.subTitleHtml });
                }
            });

        riot.tag('raw',
            '',
            function(opts) {
                if (opts.html)
                    this.root.innerHTML = opts.html;
            });

        this.primaryClick = function() {
            if (opts.model.buttons.primary.click) {
                opts.model.buttons.primary.click(opts.model);
            } else {
                opts.model.close();
            }
        };

        this.secondaryClick = function() {
            if (opts.model.buttons.secondary.click) {
                opts.model.buttons.secondary.click(opts.model);
            } else {
                opts.model.close();
            }
        };

        this.opts.model.showError = function (title, text, action) {
            opts.model.showErrorIcon = true;
            opts.model.showProgressIcon = false;
            opts.model.title = title;
            opts.model.text = text;
            opts.model.buttons = {
                secondary: {
                    title: 'OK',
                    click: action ? action : null
                }
            };
            this.update();
        };

        this.opts.model.showSuccess = function(title, text, buttonText, action) {
            opts.model.showSuccessIcon = true;
            opts.model.showErrorIcon = false;
            opts.model.showProgressIcon = false;
            opts.model.title = title;
            opts.model.text = text;
            opts.model.buttons = {
                secondary: {
                    title: buttonText ? buttonText : 'OK',
                    click: action
                }
            };
            this.update();
        };

});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-modal.riot.html